export default {
  "components.avatarDropdown.center": "Account Center",
  "components.avatarDropdown.settings": "Account Settings",
  "components.avatarDropdown.logout": "Logout",
  "components.avatarDropdown.logoutSuccess": "Logged out successfully",

  "components.siderFooter.notLoggedIn": "Not signed in",
  "components.siderFooter.login": "Login",
  "components.siderFooter.logout": "Logout",
  "components.siderFooter.logoutSuccess": "Logged out successfully",
  "components.siderFooter.subscriptionAndRecharge": "Subscription & Recharge",
  "components.siderFooter.subscribeRecharge": "Subscribe / Recharge",
  "components.siderFooter.credits": "Credits",
  "components.siderFooter.inviteLink": "Invite Link",
  "components.siderFooter.inviteLinkCopied": "Invite link copied to clipboard",
  "components.siderFooter.copyFailed": "Copy failed, please copy it manually",
  "components.siderFooter.getInviteLinkFailed": "Failed to get invite link",
  "components.siderFooter.inviteModal.title": "Invite Link",
  "components.siderFooter.inviteModal.description":
    "Share the link below to invite friends to sign up:",
  "components.siderFooter.personalAccount": "Personal account",
  "components.siderFooter.loginPromptTitle":
    "Get a more complete chat experience",
  "components.siderFooter.loginPromptDesc":
    "Sync chat history and create professional videos with templates.",
  "components.siderFooter.preferences": "Preferences",
  "components.siderFooter.language": "Language",
  "components.siderFooter.recharge": "Recharge",
  "components.siderFooter.upgrade": "Upgrade",
  "components.siderFooter.transactionHistory": "Transaction History",
  "components.siderFooter.freePlan": "Free",
  "components.siderFooter.balanceValue": "{amount}",
  "components.siderFooter.copy": "Copy",
  "common.updating": "Updating",
  "components.topNavAccount.loginOrRegister": "Login / Register",

  "components.paymentModal.title": "Subscription & Recharge",
  "components.paymentModal.tab.plans": "Plans",
  "components.paymentModal.tab.recharge": "Recharge",
  "components.paymentModal.checkoutTitle": "Confirm Payment",
  "components.paymentModal.back": "Back",
  "components.paymentModal.close": "Close",

  "components.loginModal.captchaError": "Incorrect captcha result",
  "components.loginModal.loginSuccess": "Login successful!",
  "components.loginModal.loginFailed": "Login failed, please try again!",
  "components.loginModal.googleAccessTokenMissing":
    "Google access token was not obtained",
  "components.loginModal.googleBlocked":
    "Google login is still loading or blocked. Please check your network.",
  "components.loginModal.fetchQrcodeFailed":
    "Failed to get QR code, please try again",
  "components.loginModal.registerSuccess": "Registration successful!",
  "components.loginModal.registerFailed":
    "Registration failed, please try again",
  "components.loginModal.scanDisconnected":
    "QR scan connection was interrupted, please try again",
  "components.loginModal.refreshQrcodeFailed": "Failed to refresh QR code",
  "components.loginModal.wechatScanLogin": "WeChat Scan Login",
  "components.loginModal.wechatQrcodeAlt": "WeChat QR code",
  "components.loginModal.loggingIn": "Signing in...",
  "components.loginModal.registering": "Registering...",
  "components.loginModal.refreshQrcode": "Refresh QR code",
  "components.loginModal.clickRefresh": "Click to refresh",
  "components.loginModal.wechatScanHint":
    "Open WeChat and scan to authorize login",
  "components.loginModal.wechatRegisterTitle": "Register via QR code",
  "components.loginModal.wechatRegisterSubtitle":
    "Use WeChat to scan the QR code and complete registration",
  "components.loginModal.wechatRegisterHint":
    "Open WeChat and scan\nRegistration completes automatically after scanning",
  "components.loginModal.back": "Back",
  "components.loginModal.wechatLoginHintTitle": "Scan to Login",
  "components.loginModal.wechatLoginHintSubtitle":
    "Use WeChat to scan the QR code on the left",
  "components.loginModal.wechatLoginHintDescription":
    "You will be logged in automatically after scanning",
  "components.loginModal.backToAccountLogin": "Back to account login",
  "components.loginModal.tabs.login": "Login",
  "components.loginModal.tabs.register": "Register",
  "pages.login.thirdPartyLogin": "Other login methods",
  "components.loginModal.loginForm.clientAccountRequired":
    "Please enter the enterprise account",
  "components.loginModal.loginForm.clientAccountPlaceholder":
    "Enterprise account",
  "components.loginModal.loginForm.usernameRequired":
    "Please enter the username",
  "components.loginModal.loginForm.usernamePlaceholder": "Username",
  "components.loginModal.loginForm.passwordRequired":
    "Please enter the password",
  "components.loginModal.loginForm.passwordPlaceholder": "Password",
  "components.loginModal.loginForm.captchaRequired":
    "Please enter the captcha result",
  "components.loginModal.loginForm.captchaPlaceholder": "Captcha result",
  "components.loginModal.clickRefreshShort": "Refresh",
  "components.loginModal.login": "Login",
  "components.loginModal.registerForm.clientAccountRequired":
    "Please enter the personal account ID. Only letters, numbers, underscores (_), hyphens (-), and dots (.) are allowed",
  "components.loginModal.registerForm.clientAccountPlaceholder":
    "Personal account ID",
  "components.loginModal.registerForm.clientAccountTip":
    "Personal account ID only supports letters, numbers, underscores (_), hyphens (-), and dots (.)",
  "components.loginModal.registerForm.clientAccountInvalid":
    "Personal account ID can only contain letters, numbers, underscores (_), hyphens (-), and dots (.)",
  "components.loginModal.register": "Register",
  "components.loginModal.nextStep": "Next",
  "components.loginModal.thirdPartyLogin": "Other login methods",
  "components.loginModal.googleProcessing": "Google login in progress",
  "components.loginModal.googleLogin": "Google Login",
  "components.loginModal.wechatLogin": "WeChat Login",
  "components.loginModal.googleAuthProcessing":
    "Processing Google authorization, please wait...",

  "pages.payment.plans.title": "Choose a subscription plan",
  "pages.payment.plans.pageSubtitle":
    "Compare plan benefits and choose the subscription that best fits your current pace of use.",
  "pages.payment.plans.loadFailed": "Failed to load subscription plans",
  "pages.payment.plans.loadFailedDesc":
    "Please refresh and try again later, or ask an administrator to check the payment plan configuration.",
  "pages.payment.plans.empty":
    "No subscription plans are available right now. Please contact an administrator.",
  "pages.payment.plans.emptyGroup": "No {group} plans are available right now",
  "pages.payment.plans.selected": "Selected",
  "pages.payment.plans.currentSubscription": "Current Plan",
  "pages.payment.plans.free": "Free",
  "pages.payment.plans.billingCycle.month": "month",
  "pages.payment.plans.billingCycle.year": "year",
  "pages.payment.plans.billingCycle.twoWeek": "2 weeks",
  "pages.payment.plans.billingCycle.quarter": "quarter",
  "pages.payment.plans.billingCycle.generic": "cycle",
  "pages.payment.plans.billingTab.month": "Monthly",
  "pages.payment.plans.billingTab.year": "Yearly",
  "pages.payment.plans.billingTab.twoWeek": "Promo",
  "pages.payment.plans.billingTab.specialOffer": "Special",
  "pages.payment.plans.billingTab.quarter": "Quarterly",
  "pages.payment.plans.billingTab.generic": "Plans",
  "pages.payment.plans.rollover.full": "Full quota rollover",
  "pages.payment.plans.rollover.ratio": "{ratio}% quota rollover",
  "pages.payment.plans.rollover.none": "No quota rollover",
  "pages.payment.plans.subtitle.free": "Best for first-time exploration",
  "pages.payment.plans.subtitle.specialOffer":
    "Great for short trials and quick onboarding",
  "pages.payment.plans.subtitle.basic": "Best for light daily use",
  "pages.payment.plans.subtitle.standard": "Best for stable high-frequency use",
  "pages.payment.plans.subtitle.enterprise": "Best for teams and larger quotas",
  "pages.payment.plans.subtitle.default":
    "Choose based on your current usage scale",
  "pages.payment.plans.badge.twoWeek": "Limited-time trial",
  "pages.payment.plans.badge.year": "Better value for long-term use",
  "pages.payment.plans.feature.credits": "Includes {credits} credits",
  "pages.payment.plans.feature.duration": "Valid for {days} days",
  "pages.payment.plans.purchaseLimit": "Purchase limit: {count} per user",
  "pages.payment.plans.cta.tryNow": "Try Now",
  "pages.payment.plans.cta.subscribeNow": "Subscribe Now",
  "pages.payment.plans.cta.subscribed": "Subscribed to another plan",
  "pages.payment.plans.sticky.selected": "Selected “{name}”",
  "pages.payment.plans.sticky.duration": "Valid for {days} days",
  "pages.payment.plans.sticky.meta": "{price}, includes {credits} credits",
  "pages.payment.plans.summary.active": "Current active subscription",
  "pages.payment.plans.summary.currentPlan": "Current Plan",
  "pages.payment.plans.summary.remaining": "{days} days remaining",
  "pages.payment.plans.summary.validUntil": "Active until {date}{remaining}",
  "pages.payment.plans.summary.permanent": "Permanently active",

  "pages.payment.recharge.title": "Recharge Credits",
  "pages.payment.recharge.subtitle": "Recharged credits never expire",
  "pages.payment.recharge.methodsLoadFailed": "Failed to get payment methods",
  "pages.payment.recharge.needSubscriptionFirst":
    "You need a paid subscription before recharging",
  "pages.payment.recharge.amountRequired": "Please enter a recharge amount",
  "pages.payment.recharge.amountInteger":
    "Recharge amount must be a positive integer",
  "pages.payment.recharge.disabledTitle": "Recharge is disabled",
  "pages.payment.recharge.disabledDesc":
    "Please subscribe to a paid plan before recharging.",
  "pages.payment.recharge.paymentMethod": "Payment Method",
  "pages.payment.recharge.amountLabel": "Recharge Amount ({currency})",
  "pages.payment.recharge.amountPlaceholder": "Enter recharge amount",
  "pages.payment.recharge.baseCredits": "Base Credits",
  "pages.payment.recharge.bonusCredits": "Bonus Credits",
  "pages.payment.recharge.totalCredits": "Total Credits",
  "pages.payment.recharge.goPay": "Proceed to Pay",

  "pages.payment.checkout.methodsLoadFailed": "Failed to get payment methods",
  "pages.payment.checkout.createOrderFailed": "Failed to create order",
  "pages.payment.checkout.networkInterrupted":
    "Network connection was interrupted. Please refresh the page or verify the payment result.",
  "pages.payment.checkout.title": "Confirm Payment",
  "pages.payment.checkout.pageSubtitle":
    "Review the order details and payment method before completing this subscription or recharge.",
  "pages.payment.checkout.orderType": "Order Type",
  "pages.payment.common.days": "days",
  "pages.payment.checkout.subscription": "Subscription",
  "pages.payment.checkout.recharge": "Recharge",
  "pages.payment.checkout.plan": "Plan",
  "pages.payment.checkout.duration": "Duration",
  "pages.payment.checkout.amount": "Amount",
  "pages.payment.checkout.totalCredits": "Total Credits",
  "pages.payment.checkout.creditsUnit": "credits",
  "pages.payment.checkout.settlementAmount": "Settlement Amount {amount}",
  "pages.payment.checkout.benefits.subscription":
    "Subscription benefits are granted according to the selected plan",
  "pages.payment.checkout.benefits.recharge":
    "Final credits are calculated from the settlement amount",
  "pages.payment.checkout.equivalentCny":
    "Equivalent to ¥{amount}; credits are calculated using this amount",
  "pages.payment.checkout.paymentMethod": "Payment Method",
  "pages.payment.checkout.selectPaymentMethod": "Choose Payment Method",
  "pages.payment.checkout.confirmPay": "Confirm Payment",
  "pages.payment.checkout.scanWechatPay": "Use WeChat to scan and pay",
  "pages.payment.checkout.waitingPay": "Waiting for payment...",
  "pages.payment.checkout.orderExpires": "The order will expire in 30 minutes",
  "pages.payment.checkout.paySuccess": "Payment Successful",
  "pages.payment.checkout.payFailed": "Payment Failed",
  "pages.payment.checkout.payCancelled": "Payment Cancelled",
  "pages.payment.checkout.orderNo": "Order No: {orderNo}",
  "pages.payment.checkout.close": "Close",
  "pages.payment.checkout.paypalOpened": "PayPal opened in a new window",
  "pages.payment.checkout.paypalOpenedDesc":
    "Complete the payment in PayPal. This window will refresh the result automatically.",
  "pages.payment.checkout.paypalReopen": "Open PayPal Again",
  "pages.payment.checkout.capturing": "Confirming payment...",
  "pages.payment.checkout.capturingDesc":
    "Please wait while the PayPal payment result is being processed",
  "pages.payment.checkout.capturingPaypal": "Confirming PayPal payment...",
  "pages.payment.checkout.autoClose": "This window will close automatically",
  "pages.payment.checkout.closeWindow": "Close Window",

  "pages.payment.result.pageTitle": "Payment Result",
  "pages.payment.result.pageSubtitle":
    "Review the order outcome and continue with the next available action.",
  "pages.payment.result.success": "Payment Successful",
  "pages.payment.result.cancelled": "Payment Cancelled",
  "pages.payment.result.failed": "Payment Failed",
  "pages.payment.result.backHome": "Back Home",
  "pages.payment.result.viewPlans": "View Plans",
  "pages.payment.result.orderType": "Order Type",
  "pages.payment.result.amount": "Amount",
  "pages.payment.result.status": "Status",
  "pages.payment.result.paidTime": "Paid At",
  "pages.payment.result.subscription": "Subscription",
  "pages.payment.result.recharge": "Recharge",
  "pages.payment.result.orderNo": "Order No: {orderNo}",

  "pages.payment.invite.title": "Invite Records",
  "pages.payment.invite.summary.invitees": "Invited Users",
  "pages.payment.invite.summary.rewards": "Total Rewards",
  "pages.payment.invite.col.inviteeName": "Invitee",
  "pages.payment.invite.col.totalReward": "Total Credits",
  "pages.payment.invite.col.registerTime": "Registered At",
  "pages.payment.invite.reward.eventType": "Event",
  "pages.payment.invite.reward.amount": "Credits",
  "pages.payment.invite.reward.time": "Time",
  "pages.payment.invite.noRewards": "No rewards yet",
  "pages.payment.invite.empty": "No invite records",
  "pages.payment.invite.loginRequired":
    "Please sign in to view your invite records",
  "pages.payment.invite.noInviteCode": "You do not have an invite code yet",
  "pages.payment.invite.total": "{total} invitees",
  "pages.payment.invite.myCode": "My Invite Code",
  "pages.payment.invite.myLink": "My Invite Link",
  "pages.payment.invite.copyLink": "Copy Link",
  "pages.payment.invite.codeCopied": "Invite code copied to clipboard",
  "pages.payment.invite.linkCopied": "Invite link copied to clipboard",
  "pages.payment.orders.title": "Transaction History",
  "pages.payment.orders.col.orderNo": "Order No.",
  "pages.payment.orders.col.orderType": "Type",
  "pages.payment.orders.col.orderDescription": "Description",
  "pages.payment.orders.col.paymentMethod": "Payment Method",
  "pages.payment.orders.col.amount": "Amount",
  "pages.payment.orders.col.status": "Status",
  "pages.payment.orders.col.businessId": "Business ID",
  "pages.payment.orders.col.paidTime": "Paid At",
  "pages.payment.orders.col.createTime": "Created At",
  "pages.payment.orders.search": "Search by order no",
  "pages.payment.orders.statusFilter": "Filter by status",
  "pages.payment.orders.total": "{total} orders",
  "pages.payment.orders.empty": "No transaction records",
  "pages.payment.orders.loginRequired":
    "Please sign in to view your transactions",
  "pages.payment.orders.status.INIT": "Pending",
  "pages.payment.orders.status.PAID": "Paid",
  "pages.payment.orders.status.DONE": "Completed",
  "pages.payment.orders.status.CANCELLED": "Cancelled",
  "pages.payment.orders.status.EXPIRED": "Expired",
  "pages.payment.orders.status.FAILED": "Failed",
  "pages.payment.orders.type.SUBSCRIPTION": "Subscription",
  "pages.payment.orders.type.RECHARGE": "Recharge",
  "pages.payment.orders.method.WECHAT_NATIVE": "WeChat Pay",
  "pages.payment.orders.method.PAYPAL": "PayPal",
  "pages.payment.orders.method.STRIPE": "Stripe",
  "pages.payment.orders.method.ALIPAY": "Alipay",
  "pages.payment.orders.method.BALANCE": "Balance",

  "pages.about.hero.title": "AI Video Creation Platform",
  "pages.about.hero.copy":
    'DOSSM is a commercial-grade AI creative engine purpose-built by Wintour for the travel and hospitality industry. <br> By integrating deep industry know-how with a multi-agent architecture, the platform transforms static visual assets into high-impact, 15-to-120-second professional videos. DOSSM replaces "AI randomness" with studio-quality predictability, delivering a dual breakthrough in production efficiency and brand consistency that sets a new paradigm for content marketing.',
  "pages.about.intro.enableSound": "Enable Sound",
  "pages.about.intro.mutePlayback": "Mute Playback",
  "pages.about.intro.skip": "Skip Intro",
  "pages.about.video.title": "DOSSM Product Introduction Video",
  "pages.about.guide.eyebrow": "Documentation",
  "pages.about.guide.title": "DOSSM Guide",
  "pages.about.guide.description":
    "Review the full DOSSM guide here for platform capabilities, image selection principles, and the end-to-end workflow.",
  "pages.about.guide.open": "Open Guide",
  "pages.about.guide.drawerTitle": "DOSSM Guide",
  "pages.about.guide.loading": "Loading the DOSSM guide...",
  "pages.about.guide.loadFailed":
    "Failed to load the guide. Please try again shortly.",
  "pages.about.guide.retry": "Reload",
  "pages.about.guide.back": "Back to About",
  "pages.about.guide.catalog": "Sections",
  "pages.about.guide.overview": "Overview",
  "pages.about.guide.empty": "No guide content is available right now.",
  "pages.about.contact.title": "Contact Us",
  "pages.about.contact.business": "Email",
  "pages.about.contact.phone": "Phone",
  "pages.about.contact.address": "Address",
  "pages.about.contact.addressValue":
    "Room 1202, Fangyuan E Time, No. 12-1 Keyun Road, Tianhe District, Guangzhou",
  "pages.about.contact.qrAlt": "Official support QR code",
  "pages.about.contact.qrTitle": "Exclusive 1-on-1 Service",

  "pages.workspace.justNow": "Just now",
  "pages.workspace.minutesAgo": "{count} minutes ago",
  "pages.workspace.hoursAgo": "{count} hours ago",
  "pages.workspace.yesterday": "Yesterday",
  "pages.workspace.daysAgo": "{count} days ago",
  "pages.workspace.untitledSession": "Untitled conversation",
  "pages.workspace.unpinSuccess": "Removed from pinned",
  "pages.workspace.pinSuccess": "Pinned",
  "pages.workspace.deleted": "Deleted",
  "pages.workspace.eyebrow": "Workspace",
  "pages.workspace.titleColumn": "Title",
  "pages.workspace.creditsColumn": "Credits",
  "pages.workspace.credits.cat.chat": "Reasoning",
  "pages.workspace.credits.cat.image": "Image",
  "pages.workspace.credits.cat.video": "Video",
  "pages.workspace.credits.cat.audio": "Speech",
  "pages.workspace.credits.cat.search": "Search",
  "pages.workspace.agentNameColumn": "Agent",
  "pages.workspace.updatedColumn": "Updated",
  "pages.workspace.unpin": "Unpin",
  "pages.workspace.pin": "Pin",
  "pages.workspace.deleteConfirm": "Delete this record?",
  "pages.workspace.confirm": "Confirm",
  "pages.workspace.cancel": "Cancel",
  "pages.workspace.editTitle": "Rename",
  "pages.workspace.saveTitle": "Save",
  "pages.workspace.cancelEdit": "Cancel",
  "pages.workspace.titleEmpty": "Title cannot be empty",
  "pages.workspace.renameSuccess": "Renamed",
  "pages.workspace.pageTitle": "My Work",
  "pages.workspace.search": "Search",
  "pages.workspace.status.running": "Running",
  "pages.workspace.status.waiting": "Awaiting input",
  "pages.workspace.status.disposed": "Stopped",
  "pages.workspace.status.readOnly": "View only",
  "pages.workspace.status.static": "Completed",
  "pages.workspace.pageSubtitle":
    "Review conversation status and resume work from a unified operational list.",
  "pages.workspace.recordsTitle": "Conversation Records",
  "pages.workspace.recordsSubtitle":
    "Return to running tasks, items waiting for your input, and archived working context from one list.",
  "pages.workspace.emptyDescription":
    "There are no work records yet. Start a new conversation to populate this list.",
  "pages.workspace.emptySearchDescription":
    "No conversations match the current search keyword.",
  "pages.workspace.metric.total": "Total Conversations",
  "pages.workspace.metric.running": "Running",
  "pages.workspace.metric.runningCaption": "Conversations in progress",
  "pages.workspace.metric.waiting": "Awaiting Input",
  "pages.workspace.metric.waitingCaption": "Waiting for your reply",
  "pages.workspace.metric.pinned": "Pinned",
  "pages.workspace.metric.pinnedCaption": "Prioritized for follow-up",
  "pages.workspace.loadFailed":
    "Failed to load records. Please check your network and try again.",
  "pages.workspace.loadFailedToast":
    "Failed to refresh records. Please try again.",
  "pages.workspace.loadMoreFailed": "Failed to load more records.",
  "pages.workspace.loadingMore": "Loading more records...",
  "pages.workspace.scrollLoadMore": "Scroll down to load more records",
  "pages.workspace.allLoaded": "All records loaded",
  "pages.workspace.retry": "Retry",
  "pages.workspace.refresh": "Refresh",

  "pages.welcome.badge.new": "New",
  "pages.welcome.use": "Open",
  "pages.welcome.bestPractices": "Latest Practices",
  "pages.welcome.more": "More",
  "pages.welcome.noBestPractices": "No best practices yet",
  "pages.welcome.heroPlaceholder": "Describe what you have in mind",
  "pages.welcome.heroShortcut": "Help me write a social caption",
  "pages.welcome.myAgents": "My Agents",
  "pages.welcome.agentSpace": "Agent Space",
  "pages.welcome.noDescription": "No description yet",
  "pages.welcome.lastModified": "Last modified:",
  "pages.welcome.lastViewed": "Last viewed:",
  "pages.welcome.copy": "Copy",
  "pages.welcome.pin": "Pin",
  "pages.welcome.unpin": "Unpin",
  "pages.welcome.deleteConfirm": "Delete this agent?",
  "pages.welcome.confirm": "Confirm",
  "pages.welcome.cancel": "Cancel",
  "pages.welcome.noAgents": "No agents yet",
  "pages.welcome.noPublicAgents": "No public agents yet",
  "pages.welcome.allBestPractices": "All Best Practices",
  "pages.welcome.allAgents": "All Agents",
  "pages.welcome.deleteSuccess": "Deleted successfully",
  "pages.welcome.deleteFailed": "Delete failed",
  "pages.welcome.copySuccess": "Copied successfully",
  "pages.welcome.copyFailed": "Copy failed",
  "pages.welcome.pinSuccess": "Pinned",
  "pages.welcome.unpinSuccess": "Removed from pinned",
  "pages.welcome.viewDetail": "View Details",
  "pages.welcome.firstVisit.badge": "Welcome",
  "pages.welcome.firstVisit.title":
    "Welcome to the Hospitality AI Video Platform",
  "pages.welcome.firstVisit.description":
    "Start from a prompt, browse best practices, or open an agent space built for tourism and hospitality content creation.",
  "pages.welcome.firstVisit.feature.workspace.title": "Start from one idea",
  "pages.welcome.firstVisit.feature.workspace.desc":
    "Turn your prompt into a new conversation, and continue the work in one place.",
  "pages.welcome.firstVisit.feature.agents.title": "Explore built-in agents",
  "pages.welcome.firstVisit.feature.agents.desc":
    "Open best practices and reusable agents to find the fastest starting point.",
  "pages.welcome.firstVisit.feature.video.title":
    "Create hospitality AI videos",
  "pages.welcome.firstVisit.feature.video.desc":
    "Use the platform to organize tourism and hospitality content into video-ready workflows.",
  "pages.welcome.firstVisit.hint":
    "This welcome message is only shown on your first visit.",
  "pages.welcome.firstVisit.later": "Close",
  "pages.welcome.firstVisit.start": "Confirm",

  "pages.agents.pageTitle": "My Agents",
  "pages.agents.configuredAgents": "Configured Agents ({count})",
  "pages.agents.noDescription": "No description yet",
  "pages.agents.empty": "No agents yet",
  "pages.agents.add": "Add",
  "pages.agents.addAgent": "Add Agent",
  "pages.agents.addToolAgent": "Add Tool Agent",
  "pages.agents.save": "Save",
  "pages.agents.delete": "Delete",
  "pages.agents.startWork": "Start Work",
  "pages.agents.toolAgentHint": "[Tool Agent]",
  "pages.agents.selectOne": "Please select an agent",
  "pages.agents.deleteConfirm":
    "Delete this agent? All related work data and records will also be removed.",
  "pages.agents.setToolName": "Set tool agent name",
  "pages.agents.setToolNameDesc":
    "This name is used when other agents call it as a tool",
  "pages.agents.toolNamePlaceholder": "Enter tool name (English)",
  "pages.agents.enterToolName": "Please enter a tool name",
  "pages.agents.fillRequiredFields": "Please fill in required fields",
  "pages.agents.addSuccess": "Created successfully",
  "pages.agents.saveSuccess": "Saved successfully",
  "pages.agents.deleteSuccess": "Deleted successfully",
  "pages.agents.pinSuccess": "Pinned",
  "pages.agents.unpinSuccess": "Removed from pinned",
  "pages.agents.selectType": "Choose agent type",
  "pages.agents.type.normal": "Standard Agent",
  "pages.agents.type.normalDesc":
    "A general-purpose agent that can use multiple tools to complete complex tasks",
  "pages.agents.type.tool": "Tool Agent",
  "pages.agents.type.toolDesc":
    "A specialized agent invoked by other agents as a tool",
  "pages.agents.pageSubtitle":
    "Maintain agent assets, edit capabilities, and launch work from one structured workspace.",
  "pages.agents.configuredAgentsHint":
    "Select an agent to review or edit its configuration.",
  "pages.agents.loadFailed":
    "Failed to load agents. Please check your network and try again.",
  "pages.agents.loadFailedToast": "Failed to refresh agents. Please try again.",
  "pages.agents.detailLoadFailed":
    "Failed to load agent details. Please try again.",
  "pages.agents.detailLoadFailedToast":
    "Failed to refresh agent details. Please try again.",
  "pages.agents.retry": "Retry",

  "components.agentSettingsForm.title": "Agent Name",
  "components.agentSettingsForm.titleRequired": "Please enter the agent name",
  "components.agentSettingsForm.titlePlaceholder": "Enter agent name",
  "components.agentSettingsForm.displayName": "Display Name",
  "components.agentSettingsForm.displayNamePlaceholder": "Enter display name",
  "components.agentSettingsForm.description": "Description",
  "components.agentSettingsForm.descriptionRequired":
    "Please enter a description",
  "components.agentSettingsForm.descriptionPlaceholder": "Enter description",
  "components.agentSettingsForm.model": "Reasoning Model",
  "components.agentSettingsForm.modelRequired":
    "Please select a reasoning model",
  "components.agentSettingsForm.modelPlaceholder": "Select a reasoning model",
  "components.agentSettingsForm.callLimit": "Max Execution Count",
  "components.agentSettingsForm.callLimitRequired":
    "Please enter the max execution count",
  "components.agentSettingsForm.callLimitInvalid":
    "Please enter a number between 1 and 100",
  "components.agentSettingsForm.callLimitPlaceholder":
    "Enter the max execution count",
  "components.agentSettingsForm.shareContext": "Share Context",
  "components.agentSettingsForm.shareContextRequired":
    "Please choose whether to share context",
  "components.agentSettingsForm.yes": "Yes",
  "components.agentSettingsForm.no": "No",
  "components.agentSettingsForm.systemPrompt": "Agent Prompt",
  "components.agentSettingsForm.systemPromptRequired":
    "Please enter the agent prompt",
  "components.agentSettingsForm.maximize": "Expand",
  "components.agentSettingsForm.toolParams": "Tool Parameter Definition",
  "components.agentSettingsForm.jsonValid": "Valid JSON",
  "components.agentSettingsForm.jsonInvalid": "Invalid JSON",
  "components.agentSettingsForm.empty": "Empty",
  "components.agentSettingsForm.toolParamsRequired":
    "Please enter the tool parameter definition",
  "components.agentSettingsForm.toolParamsPlaceholder":
    "Enter a JSON array of tool parameters, for example with name, type, description, and required fields",
  "components.agentSettingsForm.toolPromptTemplate": "Tool Prompt Template",
  "components.agentSettingsForm.toolPromptTemplateRequired":
    "Please enter the tool prompt template",
  "components.agentSettingsForm.jsonFormatInvalid": "Invalid JSON format",
  "components.agentSettingsForm.autoApprove": "Auto Approve",
  "components.agentSettingsForm.manualApprove": "Manual Approve",
  "components.agentSettingsForm.tab.mySkills": "My Skills ({selected}/{total})",
  "components.agentSettingsForm.tab.builtInSkills":
    "Built-in Skills ({selected}/{total})",
  "components.agentSettingsForm.tab.builtInTools":
    "Built-in Tools ({selected}/{total})",
  "components.agentSettingsForm.tab.subAgentTools":
    "Sub-agent Tools ({selected}/{total})",
  "components.agentSettingsForm.modal.role": "Role / Persona",
  "components.agentSettingsForm.modal.ability": "Ability Definition",
  "components.agentSettingsForm.modal.plan": "Task Guidance",
  "components.agentSettingsForm.modal.toolParams": "Tool Parameter Definition",
  "components.agentSettingsForm.modal.toolPrompt": "Tool Prompt Template",
  "components.agentSettingsForm.confirm": "Confirm",
  "components.agentSettingsForm.cancel": "Cancel",
  "components.agentSettingsForm.schema.name": "Parameter name",
  "components.agentSettingsForm.schema.type":
    "Parameter type (such as string, int, number, boolean, array, etc.)",
  "components.agentSettingsForm.schema.description": "Parameter description",
  "components.agentSettingsForm.schema.required":
    "Whether required (default true)",

  "components.jsonEditor.placeholder": "Enter JSON...",
  "components.jsonEditor.mustBeArray": "Data must be an array",
  "components.jsonEditor.arrayItemError": "Array item {index}: {error}",
  "components.jsonEditor.mustBeObject": "Must be an object",
  "components.jsonEditor.requiredFieldMissing":
    'Missing required field "{field}"',
  "components.jsonEditor.typeMismatch":
    'Field "{field}" has invalid type: expected {expected}, got {actual}',
  "components.jsonEditor.schemaValidationFailed": "Schema validation failed",
  "components.jsonEditor.format": "Format",
  "components.jsonEditor.jsonValid": "Valid JSON",
  "components.jsonEditor.jsonInvalid": "Invalid JSON",
  "components.jsonEditor.empty": "Empty",

  "components.toolCardList.empty": "No tools available",
  "components.toolCardList.costTooltip":
    "Credit cost level of this tool (0 to 5)",

  "pages.skills.file.apiDocs": "Tool Parameters",
  "pages.skills.file.examples": "Examples",
  "pages.skills.file.promptGuide": "Prompt Writing Guide",
  "pages.skills.pageTitle": "My Skills",
  "pages.skills.pageSubTitle":
    "Turn high-frequency workflows into reusable skill packs.",
  "pages.skills.configuredCount": "Configured Skills ({count})",
  "pages.skills.configuredHint":
    "Select a skill to review or edit its content.",
  "pages.skills.add": "Add",
  "pages.skills.unnamed": "Untitled Skill",
  "pages.skills.noDescription": "No description yet",
  "pages.skills.disabled": "Disabled",
  "pages.skills.enabled": "Enabled",
  "pages.skills.empty": "No skills yet",
  "pages.skills.addSkill": "Add Skill",
  "pages.skills.detail": "Skill Details",
  "pages.skills.copy": "Copy",
  "pages.skills.delete": "Delete",
  "pages.skills.save": "Save",
  "pages.skills.deleteConfirm": "Delete this skill?",
  "pages.skills.selectOne": "Please select a skill",
  "pages.skills.retry": "Retry",
  "pages.skills.detailLoadFailed":
    "Failed to load skill details. Please try again.",
  "pages.skills.addSuccess": "Created successfully",
  "pages.skills.saveSuccess": "Saved successfully",
  "pages.skills.deleteSuccess": "Deleted successfully",
  "pages.skills.deleteFailed": "Delete failed",
  "pages.skills.copySuccess": "Copied successfully",
  "pages.skills.fillRequiredFields": "Please fill in required fields",
  "pages.skills.generateNameNeedTitle": "Enter a title before generating",
  "pages.skills.field.title": "Skill Title (title)",
  "pages.skills.field.titleRequired": "Please enter the skill title",
  "pages.skills.field.titleExtra": "The title shown to users",
  "pages.skills.field.titlePlaceholder": "Example: Order Management",
  "pages.skills.field.name": "Skill Identifier (name)",
  "pages.skills.field.nameExtraCreate":
    "Use lowercase English letters and hyphens; the server may add a prefix to ensure uniqueness",
  "pages.skills.field.nameExtraEdit":
    "Used for references and invocation; avoid changing it",
  "pages.skills.field.nameRequired": "Please enter the skill identifier",
  "pages.skills.field.description": "Skill Description",
  "pages.skills.field.descriptionRequired":
    "Please enter the skill description",
  "pages.skills.field.descriptionPlaceholder":
    "A one-line description of what problem this skill solves",
  "pages.skills.field.enabled": "Enabled",
  "pages.skills.field.content": "Skill Content (SKILL.md)",
  "pages.skills.field.contentRequired": "Please enter the skill content",
  "pages.skills.modal.content": "Skill Content (SKILL.md)",
  "pages.skills.attachment.deleteConfirm": "Delete this attachment?",
  "pages.skills.attachment.add": "Add",
  "pages.skills.attachment.delete": "Delete",
  "pages.skills.attachment.edit": "Edit",
  "pages.skills.attachment.create": "Create",
  "pages.skills.attachment.empty": "Not configured yet",
  "pages.skills.attachment.hint":
    "Attachment content is saved with the skill and overwrites the corresponding server file.",
  "pages.skills.attachment.editModal": "Edit Attachment",
  "pages.skills.attachment.ready":
    "Content has been configured and can be edited at any time",
  "pages.skills.attachment.configured": "Configured",
  "pages.skills.attachment.unconfigured": "Not configured",
  "pages.skills.tab.attachments": "Skill Attachments ({configured}/{total})",
  "pages.skills.tab.tools": "Built-in Tools ({selected}/{total})",
  "pages.skills.tab.toolsPlain": "Tools",

  "pages.knowledge.pageTitle": "Knowledge Base",
  "pages.knowledge.pageSubtitle":
    "Manage knowledge assets and maintain document recall in one workspace.",
  "pages.knowledge.configuredCount": "Configured Knowledge Bases ({count})",
  "pages.knowledge.configuredHint":
    "Select a knowledge base to review documents or adjust its configuration.",
  "pages.knowledge.add": "Add",
  "pages.knowledge.unnamed": "Untitled",
  "pages.knowledge.noDescription": "No description yet",
  "pages.knowledge.empty": "No knowledge bases yet",
  "pages.knowledge.selectOne": "Please select a knowledge base",
  "pages.knowledge.files": "Files",
  "pages.knowledge.addFile": "Add File",
  "pages.knowledge.emptyFiles": "No files yet",
  "pages.knowledge.table.name": "Name",
  "pages.knowledge.table.uploadTime": "Uploaded At",
  "pages.knowledge.table.status": "Status",
  "pages.knowledge.table.action": "Actions",
  "pages.knowledge.menu.edit": "Edit",
  "pages.knowledge.menu.delete": "Delete",
  "pages.knowledge.menu.rename": "Rename",
  "pages.knowledge.menu.download": "Download",
  "pages.knowledge.modal.deleteTitle": "Confirm Delete",
  "pages.knowledge.modal.deleteContent":
    "Delete this knowledge base? All associated files will also be removed.",
  "pages.knowledge.modal.add": "Add Knowledge Base",
  "pages.knowledge.modal.edit": "Edit Knowledge Base",
  "pages.knowledge.field.title": "Knowledge Base Name",
  "pages.knowledge.field.titleRequired": "Please enter the knowledge base name",
  "pages.knowledge.field.titlePlaceholder": "Enter the knowledge base name",
  "pages.knowledge.field.indexName": "Index Name",
  "pages.knowledge.field.indexNameRequired": "Please enter the index name",
  "pages.knowledge.field.indexNamePlaceholder":
    "Enter the index name (for vector search)",
  "pages.knowledge.field.description": "Description",
  "pages.knowledge.field.descriptionPlaceholder":
    "Enter the knowledge base description",
  "pages.knowledge.field.minScore": "Similarity Threshold",
  "pages.knowledge.field.minScoreTooltip":
    "Minimum similarity score for retrieved results, from 0 to 1",
  "pages.knowledge.field.topN": "Recall Count",
  "pages.knowledge.field.topNTooltip":
    "Maximum number of files returned for each query",
  "pages.knowledge.upload.title": "Add File",
  "pages.knowledge.upload.text": "Drag files here or click to upload",
  "pages.knowledge.upload.hint":
    "Supports TXT, MD, PDF, DOCX, HTML, XLSX, CSV and more. Single file size must be under 15MB.",
  "pages.knowledge.rename.title": "Rename",
  "pages.knowledge.rename.placeholder": "Enter a new name",
  "pages.knowledge.createSuccess": "Created successfully",
  "pages.knowledge.saveSuccess": "Saved successfully",
  "pages.knowledge.fillRequiredFields": "Please fill in required fields",
  "pages.knowledge.deleteSuccess": "Deleted successfully",
  "pages.knowledge.renameSuccess": "Renamed successfully",
  "pages.knowledge.downloadFailed": "Download failed",
  "pages.knowledge.unsupportedFormat": "Unsupported file format: {name}",
  "pages.knowledge.uploadSuccess": "{name} uploaded successfully",
  "pages.knowledge.uploadRecordFailed": "Failed to save file record for {name}",
  "pages.knowledge.uploadFailed": "{name} upload failed",
  "pages.knowledge.loadFailed":
    "Failed to load knowledge bases. Please check your network and try again.",
  "pages.knowledge.loadFailedToast":
    "Failed to refresh knowledge bases. Please try again.",
  "pages.knowledge.filesLoadFailed": "Failed to load files. Please try again.",
  "pages.knowledge.filesLoadFailedToast":
    "Failed to refresh files. Please try again.",
  "pages.knowledge.retry": "Retry",

  "pages.login.googleBlocked":
    "Google login is still loading or blocked. Please check your network.",
  "pages.login.googleFailed": "Google login failed, please try again!",
  "pages.login.googleProcessing": "Google login in progress",
  "pages.login.googleLogin": "Google Login",
  "pages.login.googleAuthProcessing":
    "Processing Google authorization, please wait...",
  "pages.login.wechatComingSoon": "WeChat QR login is not enabled yet",
  "pages.login.googleAccessTokenMissing":
    "Google access token was not obtained",

  "pages.dashboard.accountData": "Account Data",
  "pages.dashboard.currentBalance": "Current Credit Balance",
  "pages.dashboard.totalSpent": "Historical Credit Usage",
  "pages.dashboard.requestCount": "Request Count",
  "pages.dashboard.threadCount": "Work Count",
  "pages.dashboard.inference": "Inference",
  "pages.dashboard.image": "Image",
  "pages.dashboard.video": "Video",
  "pages.dashboard.audio": "Audio",
  "pages.dashboard.credits": "Credits",
  "pages.dashboard.images": "Images",
  "pages.dashboard.seconds": "Seconds",
  "pages.dashboard.characters": "Characters",
  "pages.dashboard.modelAnalysis": "Model Analytics",
  "pages.dashboard.last24Hours": "24 Hours",
  "pages.dashboard.last7Days": "7 Days",
  "pages.dashboard.consumptionDistribution": "Consumption",
  "pages.dashboard.callCountDistribution": "Call Count",
  "pages.dashboard.noModelData": "No model usage data yet",
  "pages.dashboard.noModelDataHint":
    "Data will appear here after you start using AI models",
  "pages.dashboard.usageRecords.title": "Usage Details",
  "pages.dashboard.usageRecords.totalSpent": "Credits Used: {amount}",
  "pages.dashboard.usageRecords.modelNamePlaceholder": "Model name",
  "pages.dashboard.usageRecords.typePlaceholder": "Type",
  "pages.dashboard.usageRecords.search": "Search",
  "pages.dashboard.usageRecords.reset": "Reset",
  "pages.dashboard.usageRecords.col.time": "Time",
  "pages.dashboard.usageRecords.col.type": "Type",
  "pages.dashboard.usageRecords.col.model": "Model",
  "pages.dashboard.usageRecords.col.latency": "Latency",
  "pages.dashboard.usageRecords.col.credits": "Credits",
  "pages.dashboard.usageRecords.col.status": "Status",
  "pages.dashboard.usageRecords.typeAll": "All",
  "pages.dashboard.usageRecords.typeChat": "Inference Token",
  "pages.dashboard.usageRecords.typeImageGen": "Image Generation",
  "pages.dashboard.usageRecords.typeVideoGen": "Video Generation",
  "pages.dashboard.usageRecords.typeAudioTts": "Text to Speech",
  "pages.dashboard.usageRecords.typeSearch": "Web Search",
  "pages.dashboard.usageRecords.tagChat": "Inference",
  "pages.dashboard.usageRecords.tagImage": "Image",
  "pages.dashboard.usageRecords.tagVideo": "Video",
  "pages.dashboard.usageRecords.tagAudio": "Audio",
  "pages.dashboard.usageRecords.tagSearch": "Search",
  "pages.dashboard.usageRecords.paginationTotal": "{start}-{end} of {total}",
  "pages.dashboard.usageRecords.emptyText": "No results found",
  "pages.resources.pageTitle": "Resources",
  "pages.resources.pageSubtitle":
    "Browse shared materials and system resources in a consistent workspace view.",
  "pages.resources.comingSoon": "Knowledge base page — coming soon",

  "editor.properties": "Properties",
  "editor.properties.selectElement": "Select an element to edit",
  "editor.properties.transform": "Transform",
  "editor.properties.position": "Position",
  "editor.properties.scale": "Scale",
  "editor.properties.rotate": "Rotate",
  "editor.properties.opacity": "Opacity",
  "editor.properties.blendMode": "Blend Mode",
  "editor.properties.text": "Text",
  "editor.properties.content": "Content",
  "editor.properties.fontSize": "Font Size",
  "editor.properties.fontFamily": "Font",
  "editor.properties.color": "Color",
  "editor.properties.textAlign": "Align",
  "editor.properties.fontWeight": "Bold",
  "editor.properties.fontStyle": "Italic",
  "editor.properties.textDecoration": "Decoration",
  "editor.properties.letterSpacing": "Spacing",
  "editor.properties.lineHeight": "Line H",
  "editor.properties.background": "Background",
  "editor.properties.cornerRadius": "Radius",
  "editor.properties.padding": "Padding",
  "editor.properties.effects": "Effects",
  "editor.properties.addEffect": "Add Effect",
  "editor.properties.audio": "Audio",
  "editor.properties.subtitle": "Subtitle",
  "editor.properties.subtitleY": "Bottom Margin",
  "editor.properties.subtitleBg": "BG Color",
  "editor.properties.stroke": "Stroke",
  "editor.properties.shadow": "Shadow",
  "editor.properties.textAnimation": "Text Animation",
  "editor.properties.preset": "Preset",
  "editor.properties.duration": "Duration",
  "editor.properties.textAnimation.none": "None",
  "editor.properties.textAnimation.typewriter": "Typewriter",
  "editor.properties.textAnimation.perCharFade": "Per-character Fade",
  "editor.properties.textAnimation.fadeIn": "Fade In",
  "editor.properties.volume": "Volume",
  "editor.properties.fadeIn": "Fade In",
  "editor.properties.fadeOut": "Fade Out",
  "editor.properties.duckTrigger": "Duck Trigger",
  "editor.properties.ducking": "Enable Auto Ducking",
  "editor.properties.muted": "Muted",
  "editor.properties.playbackRate": "Playback Rate",
  "editor.properties.speed": "Speed",
  "editor.properties.reverse": "Reverse",
  "editor.properties.effectTrack": "Effect Track",
  "editor.properties.effectType": "Effect Type",
  "editor.properties.enterExit": "Enter / Exit",
  "editor.properties.enterExit.enter": "Enter",
  "editor.properties.enterExit.exit": "Exit",
  "editor.properties.enterExit.duration": "Duration",
  "editor.properties.enterExit.none": "None",
  "editor.properties.enterExit.fade": "Fade",
  "editor.properties.enterExit.slideLeft": "Slide Left",
  "editor.properties.enterExit.slideRight": "Slide Right",
  "editor.properties.enterExit.slideUp": "Slide Up",
  "editor.properties.enterExit.slideDown": "Slide Down",
  "editor.properties.enterExit.zoomIn": "Zoom In",
  "editor.properties.enterExit.zoomOut": "Zoom Out",
  "editor.properties.enterExit.rotateIn": "Rotate In",
  "editor.properties.enterExit.bounceIn": "Bounce In",
  "editor.properties.easing.linear": "Linear",
  "editor.properties.easing.easeIn": "Ease In",
  "editor.properties.easing.easeOut": "Ease Out",
  "editor.properties.easing.easeInOut": "Ease In Out",
  "editor.properties.easing.hold": "Hold",
  "editor.properties.easingTooltip":
    "Choose how the animation accelerates and decelerates over time",
  "editor.timeline": "Timeline",
  "editor.timeline.importMedia": "Import media to get started",
  "editor.timeline.track.mainTrack": "Main Track",
  "editor.timeline.track.image": "Image Track",
  "editor.timeline.track.text": "Text",
  "editor.timeline.track.audio": "Audio",
  "editor.timeline.track.sticker": "Sticker",
  "editor.timeline.track.effect": "Effect",
  "editor.timeline.track.subtitle": "Subtitle",
  "editor.timeline.split": "Split",
  "editor.timeline.duplicate": "Duplicate",
  "editor.timeline.delete": "Delete",
  "editor.timeline.detachAudio": "Detach Audio",
  "editor.timeline.lock": "Lock Track",
  "editor.timeline.unlock": "Unlock Track",
  "editor.timeline.solo": "Solo",
  "editor.timeline.unsolo": "Unsolo",
  "editor.timeline.reverse": "Reverse",
  "editor.timeline.rippleEdit": "Ripple Edit",
  "editor.timeline.beatMode": "Beats",
  "editor.timeline.beatMode.failed": "Could not detect beats",
  "editor.timeline.undo": "Undo",
  "editor.timeline.redo": "Redo",
  "editor.assets": "Assets",
  "editor.assets.type.video": "Video",
  "editor.assets.type.image": "Image",
  "editor.assets.type.audio": "Audio",
  "editor.assets.addText": "Add Text",
  "editor.assets.addSticker": "Add Sticker",
  "editor.assets.addEffect": "Add Effect",
  "editor.assets.import": "Import media files",
  "editor.assets.importSubtitle": "Import Subtitles",
  "editor.assets.dragDrop": "Drag & drop files here",
  "editor.assets.filterTag": "Filter by Tag",
  "editor.assets.favorite": "Favorite",
  "editor.scenes.deleteConfirm": "Delete this scene?",
  "editor.scenes.deleteOk": "Delete",
  "editor.scenes.deleteCancel": "Cancel",
  "editor.scenes.addScene": "Add Scene",
  "editor.assets.delete.confirm.title": "Confirm Delete",
  "editor.assets.delete.confirm.content": 'Delete asset "{name}"?',
  "editor.assets.delete.inUse.title": "Cannot Delete",
  "editor.assets.delete.inUse.content":
    "This asset is used by {count} element(s) on the timeline. Remove them first.",
  "editor.preview": "Preview",
  "editor.preview.play": "Play",
  "editor.preview.pause": "Pause",
  "editor.preview.loop": "Loop Playback",
  "editor.preview.inPoint": "In Point (I)",
  "editor.preview.outPoint": "Out Point (O)",
  "editor.preview.clearInOut": "Clear In/Out Points",
  "editor.preview.guides": "Guides",
  "editor.preview.guides.center": "Center Line",
  "editor.preview.guides.thirds": "Rule of Thirds",
  "editor.preview.guides.safeArea": "Safe Area",
  "editor.header.export": "Export",
  "editor.header.exporting": "Exporting...",
  "editor.header.format": "Format",
  "editor.header.quality": "Quality",
  "editor.header.saveToCloud": "Save to Cloud",
  "editor.export.title": "Export Video",
  "editor.export.cancel": "Cancel",
  "editor.export.renderingFrames": "Rendering frames...",
  "editor.export.encodingVideo": "Encoding video...",
  "editor.export.done": "Done",
  "editor.export.completed": "Export completed",
  "editor.export.cancelled": "Export cancelled",
  "editor.export.failed": "Export failed",
  "editor.export.savedToCloud": "Exported & saved to cloud",
  "editor.export.cloudUploadFailed":
    "Downloaded locally, but cloud upload failed",
  "editor.export.quality.low": "Low",
  "editor.export.quality.medium": "Medium",
  "editor.export.quality.high": "High",
  "editor.export.quality.veryHigh": "Very High",
  "editor.transition.select": "Select Transition",
  "editor.transition.add": "Add Transition",
  "editor.transition.remove": "Remove Transition",
  "editor.transition.duration": "Transition Duration",
  "editor.transition.fade": "Fade",
  "editor.transition.fadeblack": "Fade Black",
  "editor.transition.fadewhite": "Fade White",
  "editor.transition.wipeleft": "Wipe Left",
  "editor.transition.wiperight": "Wipe Right",
  "editor.transition.wipeup": "Wipe Up",
  "editor.transition.wipedown": "Wipe Down",
  "editor.transition.slideleft": "Slide Left",
  "editor.transition.slideright": "Slide Right",
  "editor.transition.slideup": "Slide Up",
  "editor.transition.slidedown": "Slide Down",
  "editor.transition.circlecrop": "Circle Crop",
  "editor.transition.circleopen": "Circle Open",
  "editor.transition.circleclose": "Circle Close",
  "editor.transition.dissolve": "Dissolve",
  "editor.transition.pixelize": "Pixelize",
  "editor.transition.radial": "Radial",
  "editor.transition.smoothleft": "Smooth Left",
  "editor.transition.smoothright": "Smooth Right",
  "editor.transition.smoothup": "Smooth Up",
  "editor.transition.smoothdown": "Smooth Down",
  "editor.transition.diagtl": "Diag Top-Left",
  "editor.transition.diagtr": "Diag Top-Right",
  "editor.transition.diagbl": "Diag Bot-Left",
  "editor.transition.diagbr": "Diag Bot-Right",
  "editor.transition.hlslice": "H-Slice Left",
  "editor.transition.hrslice": "H-Slice Right",
  "editor.transition.vuslice": "V-Slice Up",
  "editor.transition.vdslice": "V-Slice Down",
  "editor.transition.horzopen": "Horz Open",
  "editor.transition.horzclose": "Horz Close",
  "editor.transition.vertopen": "Vert Open",
  "editor.transition.vertclose": "Vert Close",
  "editor.transition.squeezeh": "Squeeze H",
  "editor.transition.squeezev": "Squeeze V",
  "editor.transition.mode": "Transition Mode",
  "editor.transition.mode.overlap": "Overlap",
  "editor.transition.mode.freeze": "Freeze Frame",
  "editor.transition.gap.warning":
    "Cannot add transition: there is a gap between the clips. Close the gap first.",
  "editor.properties.addKeyframe": "Add Keyframe",
  "editor.properties.removeKeyframe": "Remove Keyframe",
  "editor.properties.fontGroup.system": "System Fonts",
  "editor.properties.fontGroup.google": "Google Fonts",
  "editor.properties.colorPresets": "Common",
  "editor.preview.fullscreen": "Fullscreen",
  "editor.preview.exitFullscreen": "Exit Fullscreen",
  "editor.properties.canvas": "Canvas",
  "editor.properties.canvasSize": "Size",
  "editor.properties.canvasWidth": "W",
  "editor.properties.canvasHeight": "H",
  "editor.properties.canvasPreset": "Preset",
  "editor.properties.canvasPreset.landscape": "16:9 Landscape",
  "editor.properties.canvasPreset.portrait": "9:16 Portrait",
  "editor.properties.canvasPreset.square": "1:1 Square",
  "editor.properties.canvasPreset.fourThree": "4:3",
  "editor.properties.canvasPreset.custom": "Custom",
  "editor.properties.objectFit": "Fit",
  "editor.properties.objectFit.cover": "Cover",
  "editor.properties.objectFit.contain": "Contain",
  "editor.properties.objectFit.fill": "Fill",
  "editor.properties.objectFit.none": "None",
  "editor.properties.elementsSelected": "elements selected",
  "editor.pageTitle": "Video Editor",
  "editor.pageTitleWithName": "Video Editor - {name}",
};
